<template>
  <div class="echars">
    <div id="echarth-nianling"></div>
  </div>
</template>

<script>
export default {
  name: "echarth-nianling",
  data() {
    return {
      data: 0,
      data1:0,
      data2: 0,
      data3: 0,
      data4: 0,
      data5: 0,
    }
  },
  props:['title'],
  watch: {
        title: function (newData) {
           let value1 = newData
            console.log(value1,'1231231')
            value1.forEach((item,index)=>{         
                if(18<=item.age<30&&item.age<30){
                  this.data+=item.count
                }else if(30<=item.age<40&&item.age<40){
                  this.data1+=item.count
                }else if(40<=item.age<50&&item.age<50){
                  this.data2+=item.count
                }else if(50<=item.age<=60&&item.age<=60){
                  this.data3+=item.count
                }else if(item.age>60){
                  this.data4+=item.count
                }else{
                  this.data5+=item.count
                }  
            })
            console.log(this.data,this.data1,this.data2,this.data3,this.data4,this.data5)
            this.mapFn(this.data,this.data1,this.data2,this.data3,this.data4,this.data5)
        }
    },
  methods: {
    mapFn(data,data1,data2,data3,data4,data5) {
      // 基于准备好的dom，初始化echarts实例
      // var mapChart = this.$echarts.init(this.$refs.mapChart);
      var mapChart = this.$echarts.init(
        document.getElementById("echarth-nianling")
      );
      document
        .getElementById("echarth-nianling")
        .removeAttribute("_echarts_instance_");
      mapChart.setOption({
         color: ["#0b41eb","#34a1f7","#81afd4","#b4d5f1"],
  series: [
    { min:70,
      type: 'pie',
      radius: [0, 150],
      center: ['48%', '48%'],
      roseType: 'radius',
      label: {
              show: true,
              position: "outside",
              formatter: "{b}-{d}%",
            },
            labelLine: {
    normal: {
        length: -20, //第一条线
        length2: 8, //第二条线
        lineStyle: {
            width: 1, // 线条的宽度color: "#000", //线的颜色设置， 如没有设置颜色则线条的颜色跟随饼状图的颜色
        }
    }
},
      itemStyle: {
        borderRadius: 0
      },
      data: [
        {value:data4,name:'60岁以上'},
        { value: data3, name: '50-60岁' },
        { value: data2, name: '40-50岁' },
        { value: data1, name: '30-40岁' },
        { value: data, name: '18-30岁' }, 
        { value: data5, name: '18岁以下' }, 
      ]
    }
  ]
      }),
        window.addEventListener("resize", () => {
          // 自动渲染echarts
          mapChart.resize();
        });
    },
  },
};
</script>
<style scoped>
.echars {
  width: 23vw;
  height: 35vh;
}
#echarth-nianling {
  width: 23vw;
  height: 35vh;
}
</style>
